<template>
  <div class="item-base"  @click="handleDetail(ItemData.id)">
    <div class="item-left">
      <el-image class="img" :src="'http://'+ItemData.mainPhotoUrl"></el-image>
    </div>
    <div class="item-right">
      <span>{{ItemData.title}}</span>
      <pre>{{ItemData.mainDescription}}</pre>
      <ul>{{ItemData.eventTime}}</ul>
    </div>
  </div>
</template>

<script>
  export default {
    name: "NewsItem",
    props:{
      ItemData:{}
    },
    methods:{
      handleDetail(id){
        this.$router.push('/news/detail/'+id)
      }
    }
  }
</script>

<style lang="less" scoped>
  .item-base{
    margin: 18px 0;
    display: flex;

    .item-left{
      margin-right: 20px;
      .img{
        width: 11.4vw;
        height: 140px;
        border-radius: 4px;
      }
    }
    .item-right{

      width: 55.2vw;
      span{

        height: 24px;
        font-size: 24px;
        font-family: SourceHanSansCN-Bold, SourceHanSansCN;
        font-weight: bold;
        color: #333333;
        line-height: 36px;

      }
      pre{
        margin-top: 10px;
        height: 72px;
        font-size: 14px;
        font-family: SourceHanSansCN-Regular, SourceHanSansCN;
        font-weight: 400;
        color: #666666;
        line-height: 24px;
        white-space: pre-wrap;
        overflow: hidden;
      }
      ul{
        height: 12px;
        font-size: 12px;
        font-family: SourceHanSansCN-Regular, SourceHanSansCN;
        font-weight: 400;
        color: #999999;
        line-height: 18px;

      }
    }
  }
</style>